export const getSmartStartProgress = (continueWatchingIsActive, continueWatchingItems, smartStart) => {
    if (!continueWatchingIsActive) {
        return null;
    }

    let progress;
    const smartStartContinueWatching = continueWatchingItems?.find((item) => {
        return item.videoId === smartStart?.item.id;
    });

    if (smartStartContinueWatching) {
        progress = Math.round((smartStartContinueWatching.position / smartStart?.item.duration) * 100);
    }

    return progress;
};

export const getAssociatedContentProgress = (
    continueWatchingIsActive,
    continueWatchingItems,
    associatedContent
) => {
    if (!continueWatchingIsActive) {
        return null;
    }

    const associatedContentProgress = associatedContent.reduce((result, section) => {
        section.items?.forEach((item) => {
            const match = continueWatchingItems.find((continueWatchingItem) => {
                return continueWatchingItem.videoId.startsWith(item.item.id);
            });

            if (match) {
                const progress = Math.round((match.position / item.item.duration) * 100);

                result[item.item.svtId] = progress;
            }
        });

        return result;
    }, {});

    return associatedContentProgress;
};

export const getSubheading = (item, isTitle) => {
    const type = item.parent?.__typename;

    if (type === 'Single') {
        return item.durationFormatted;
    }

    if (isTitle) {
        return item?.shortDescription;
    }

    return `${item.name} • ${item.durationFormatted}`;
};
